module.exports = __webpack_public_path__ + "montserrat-bolditalic-webfont.8b28b083ac8baf0a4005.woff2";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/fonts/montserrat-bolditalic-webfont.woff2
// module id = ../../../../../src/assets/fonts/montserrat-bolditalic-webfont.woff2
// module chunks = styles